import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from 'react';
import Form from "react-validation/build/form";
import APIConfig from "../../../api/APIConfig";
import swal from 'sweetalert';

import {
    Box,
    Center,
    Heading,
    Button,
    Text,
    Stack,
    Alert,
    VStack,
    useColorModeValue,
    FormControl,
    FormLabel,
} from '@chakra-ui/react';

function EditBuktiPembayaran() {
    const navigate = useNavigate();
    const [selectedFiles, setSelectedFiles] = useState(undefined);
    const [image, setImage] = useState('');
    const [srcData, setSrcData] = useState('');
    const [atasNama, setAtasNama] = useState('');
    const [nomorRekening, setNomorRekening] = useState('');
    const [namaBank, setNamaBank] = useState('');
    const { id } = useParams();
    const [imageUrl, setImageUrl] = useState(undefined);
    const [validation, setValidation] = useState({});

    useEffect(() => {
        getBuktiPembayaranById();
        
    }, []);

    const getBuktiPembayaranById = async() => {
        const response = await APIConfig.get(`/v1/lowonganpeserta/${id}`);
        const data = await response.data
        const obj = JSON.parse(data.image);

        setSelectedFiles(obj.image);
        setAtasNama(data.atasNama);
        setNomorRekening(data.nomorRekening);
        setNamaBank(data.namaBank);
    };

    function selectFiles(event){
        var fileSelected = event.target.files;

        if(fileSelected.length > 0) {
            var fileToLoad = fileSelected[0];
            setSelectedFiles(fileToLoad);
            setImageUrl(URL.createObjectURL(fileToLoad));

            var reader = new FileReader();
            reader.onload = function(fileLoadedEvent) {
                setSrcData(fileLoadedEvent.target.result)
            }
            reader.readAsDataURL(fileToLoad)
        }
    }

    const uploadImage = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("file", image);
        data.append("upload_preset", "magangpro")
        data.append("cloud_name", "dlbioqgfd")

        fetch("https://api.cloudinary.com/v1_1/dlbioqgfd/image/upload",{
            method:"post",
            body: data
        })
        .then(() => {
                setSrcData(data.url);
                APIConfig.put(`v1/buktipembayaran/${id}`, {
                    image: srcData,
                })
                swal({
                    title: "Bukti pembayaran berhasil diupload!",
                    icon: "success",
                    button: "OK",
                })
                .then(() => {
                    console.log("berhasil uploadddd") 
                    navigate(`/peserta/kegiatanku/buktipembayaran/${id}`); 
                })
            })
        .catch((error) => {
            console.log(error);
            setValidation(error.response.data);
        })
    };

    return (
        <Center py={6}>
        <VStack justifyItems='left' fontFamily={'Inter'} 
                marginRight={'50px'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                letterSpacing={1.1}
                fontFamily={'Inter'}>
                Upload Bukti Pembayaran
            </Text>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>

                {
                    validation.errors &&
                        <Alert variant="danger">
                            <ul class="mt-0 mb-0">
                                { validation.errors.map((error, index) => (
                                    <li key={index}>{ `${error.param} : ${error.msg}` }</li>
                                )) }
                            </ul>
                        </Alert>
                }

                <Form onSubmit={uploadImage}>
                    <VStack 
                    spacing={4}
                    align='stretch'
                    p={3}
                    >
                        
                        <Heading
                            mb={6}
                            mt={3}
                            color={useColorModeValue('gray.700', 'white')}
                            fontSize={'xl'}
                            fontFamily={'Inter'}>
                            Upload Bukti Pembayaran
                        </Heading>
                        <FormControl pb={2} fontFamily={'Inter'}>
                            <FormLabel htmlFor='logo'>Pilih foto</FormLabel>
                            {imageUrl===undefined ? (
                                null
                            ) : (
                                <img style={{width: '20%', height: '20%', marginBottom: '10px'}} className="preview" src={imageUrl} alt="" />
                            )}
                            <input 
                                id='logo' className="custom-file-input" 
                                type='file' accept="image/*" 
                                placeholder="Pilih file"
                                onChange={selectFiles}
                            />
                        </FormControl>
                    </VStack>
                    <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                        <Button 
                            onClick={() => navigate(-1)}
                            p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                            Kembali
                        </Button>
                        <Button 
                            disabled={!selectedFiles}
                            type='submit'
                            p={6}
                            colorScheme='purple' 
                            rounded={'xl'}
                            variant='solid'>
                            Simpan
                        </Button>
                    </Stack>
                </Form>
            </Box>
        </VStack>
        </Center>
    );
}

export default EditBuktiPembayaran;